import { useContext, useEffect, useState } from "react"
import { ProfileContext, ProfileContextPayload } from "../../../Context/ProfileDetailsContext"
import { Grid, Typography } from "@mui/material"
import styles from "../../../Styles/ComponentStyles/ProfileStyle/AccValueTab.module.scss"
import CustomNumberTextField from "../../../GlobalComponent/CustomNumberTextField/CustomNumberTextField"

const AnnuityFeesTab = () => {
    const {
        finalData
    } = useContext(ProfileContext) as ProfileContextPayload

    const [changeYearTypical, setChangeYearTypical] = useState(finalData?.current_age)
    const [changeYearAccum, setchangeYearAccum] = useState(finalData?.current_age)

    const [feeTpAgeMin, setFeeTpAgeMin] = useState<number | null>(null);
    const [feeTpAgeMax, setFeeTpAgeMax] = useState<number | null>(null);
    const [feeAccAgeMin, setFeeAccAgeMin] = useState<number | null>(null);
    const [feeAccAgeMax, setFeeAccAgeMax] = useState<number | null>(null);

    const [taxTypicalAgeArray, setTaxTypicalAgeArray] = useState<number[]>([]);
    const [flagShowCalculationErrorTp, setCalculationShowErrorTp] = useState(false);

    useEffect(() => {
        if (finalData?.typical_plan?.FEES_age_data && finalData?.accumulation_plan) {
            const feesTypicalAge = Object.keys(finalData.typical_plan.FEES_age_data).map(Number);
            const feesAccumulation_planAge = Object.keys(finalData.accumulation_plan).map(Number);

            setTaxTypicalAgeArray(feesTypicalAge)

            setFeeTpAgeMin(feesTypicalAge[0]);
            setFeeTpAgeMax(feesTypicalAge[feesTypicalAge.length - 1]);
            setFeeAccAgeMin(feesAccumulation_planAge[0]);
            setFeeAccAgeMax(feesAccumulation_planAge[feesAccumulation_planAge.length - 1]);

            setChangeYearTypical(feesTypicalAge[0]);
            setchangeYearAccum(feesAccumulation_planAge[0]);
        }
    }, [finalData]);

    useEffect(() => {
        if (changeYearTypical == Number(taxTypicalAgeArray[taxTypicalAgeArray?.length - 1])) {
            setCalculationShowErrorTp(true)
        } else {
            setCalculationShowErrorTp(false)
        }
    }, [changeYearTypical])

    const formatNumber = (q: any) => {
        if (q || q == 0) {
            return q.toLocaleString('en-US', {
                style: 'currency',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                currency: "usd"
            })
        }
    }

    const InputchangeYearAccum = (e: any) => {
        let val = parseInt(e.target.value);
        if (val >= Number(feeAccAgeMin) && val <= Number(feeAccAgeMax)) {
            setchangeYearAccum(val)
        }
        else {
            if (val >= Number(feeAccAgeMax))
                setchangeYearAccum(Number(feeAccAgeMax))
            else {
                setchangeYearAccum(Number(feeAccAgeMin))
            }
            return;
        }
    }

    const InputBlurChangeIUL = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(feeAccAgeMin), Number(feeAccAgeMax), val)
        if (checkInBeetween == false) {
            if (val >= Number(feeAccAgeMax))
                setchangeYearAccum(Number(feeAccAgeMax))
            else {
                setchangeYearAccum(Number(feeAccAgeMin))
            }
            return
        }
    }

    const inputChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        if (val >= Number(feeTpAgeMin) && val <= Number(feeTpAgeMax)) {
            setChangeYearTypical(val)
        }
        else {

            if (val >= Number(feeTpAgeMax))
                setChangeYearTypical(Number(feeTpAgeMax))
            else {
                setChangeYearTypical(Number(feeTpAgeMin))
            }
            return;
        }
    }

    const isInputBetween = (num1: any, num2: any, value: any) => value > num1 && value < num2;
    const inputBlureChangeYear = (e: any) => {
        let val = parseInt(e.target.value);
        let checkInBeetween = isInputBetween(Number(feeTpAgeMin), Number(feeTpAgeMax), val)
        if (checkInBeetween == false) {
            if (val >= Number(feeTpAgeMax))
                setChangeYearTypical(Number(feeTpAgeMax))
            else {
                setChangeYearTypical(Number(feeTpAgeMin))
            }
            return
        }
    }

    return (
        <>
            <Grid container className={styles.accValueTabWrapper}>
                {/* TYPICAL PLAN */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} className={flagShowCalculationErrorTp ? styles.accValueErrorStyleWrapper : undefined} sx={{ borderRight: "1px solid #E2E8F0" }}>
                    <Grid container>
                        <Grid item xs={12} className={styles.headerContainer}>
                            <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <Grid item>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.typicalPlanTxt}>Typical Plan</Grid>
                                        <Grid item xs={12} className={styles.typicalPlanSubTxt}>Traditional Plan</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container gap={"10px"} alignItems={"center"}>
                                        <Grid item>
                                            <span className={styles.headerIdentifier}>BASELINE</span>
                                        </Grid>
                                        <Grid item>
                                            <CustomNumberTextField
                                                type="number"
                                                size="small"
                                                variant="outlined"
                                                value={changeYearTypical}
                                                onChange={(e) => {
                                                    setChangeYearTypical(e?.target?.value);
                                                }}
                                                InputProps={{ inputProps: { min: feeTpAgeMin, max: feeTpAgeMax } }}
                                                onBlur={inputBlureChangeYear}
                                                onKeyUp={(e) => {
                                                    if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode == 13)
                                                        inputChangeYear(e);
                                                }}
                                                customStyles={{
                                                    backgroundColor: "white",
                                                    color: "black"
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={styles.fieldContainer}>
                            <Grid container gap="10px">
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item className={styles.outputLabel} xs={10}>Current Age</Grid>
                                        <Grid item className={styles.outputValue} xs={2}>{changeYearTypical || 0}</Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Age at Retirement</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{finalData?.ageAtRetirement || 0}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={styles.greyContainer}>
                            <Grid container gap="10px">
                                <Grid item xs={12} className={styles.sectionTitle}>Account Setup</Grid>

                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Contributions</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.yearly_contribution?.[changeYearTypical]) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Starting Account Balance</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{formatNumber(finalData?.typical_plan?.currAccountBalance) || "$0"}</Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Account Balance with Contributions</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.FEES_age_data?.[changeYearTypical]?.balance) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={styles.fieldContainer}>
                            <Grid container gap="10px">
                                <Grid item xs={12} className={styles.sectionTitle}>Returns & Fees</Grid>

                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Rate of Return</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>{finalData?.typical_plan?.rateOfReturnWorking || 0}%</Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Fees</Grid>
                                        <Grid item xs={2}>
                                            <Grid container alignItems="center" gap="5px">
                                                <Grid item className={styles.typicalFeesValue}>
                                                    {(finalData?.typical_plan?.percentFees || 0)}%
                                                </Grid>
                                                <Grid item>
                                                    <span className={styles.typicalFeesText}>Annual</span>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={styles.lightblueContainer}>
                            <Grid container gap="10px">
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" gap="10px">
                                        <Grid item>
                                            <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                        </Grid>
                                        <Grid item>
                                            <Typography component={"span"} className={styles.sectionTitle}>Fees - No Life Insurance</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Fees</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.FEES_age_data?.[changeYearTypical]?.annual_fees) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Fees Paid</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.typical_plan?.FEES_age_data?.[changeYearTypical]?.total_fees_paid) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        {flagShowCalculationErrorTp &&
                            <Grid item xs={12} className={styles.typicalValueEmptyTxt}>
                                Typical plan account value is empty
                            </Grid>
                        }
                    </Grid>
                </Grid>
                {/* ANNUITY - ACCUMULATION PLAN */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid container>
                        <Grid item xs={12} className={styles.headerContainer}>
                            <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <Grid item>
                                    <Grid container>
                                        <Grid item xs={12} className={styles.typicalPlanTxt}>
                                            Annuity - Accumulation
                                        </Grid>
                                        <Grid item xs={12} className={styles.typicalPlanSubTxt}>
                                            Traditional Plan
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container gap={"10px"} alignItems={"center"}>
                                        <Grid item>
                                            <span className={styles.headerIdentifier}>COMPARISON</span>
                                        </Grid>
                                        <Grid item>
                                            <CustomNumberTextField
                                                type="number"
                                                size="small"
                                                variant="outlined"
                                                defaultValue={changeYearAccum}
                                                onChange={(e) => {
                                                    setchangeYearAccum(e?.target?.value);
                                                }}
                                                InputProps={{ inputProps: { min: feeAccAgeMin, max: feeAccAgeMax } }}
                                                onBlur={InputBlurChangeIUL}
                                                onKeyUp={(e) => {
                                                    if (e.keyCode === 40 || e.keyCode === 38 || e.keyCode == 13)
                                                        InputchangeYearAccum(e);
                                                }}
                                                value={changeYearAccum}
                                                customStyles={{
                                                    backgroundColor: "white",
                                                    color: "black"
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={styles.fieldContainer} paddingBottom={"115px"}>
                            <Grid container gap="10px">
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Starting Account Balance</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.accumulation_plan?.[changeYearAccum]?.amountAtStart) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Post-Interest Account Balance</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.accumulation_plan?.[changeYearAccum]?.currentBalance) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}># Years</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {finalData?.accumulation_plan?.[changeYearAccum]?.year || "0"}{" "}
                                            {finalData?.accumulation_plan?.[changeYearAccum]?.year > 1 ? "Years" : "Year"}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Interest Rate %</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {finalData?.accumulation_plan?.[changeYearAccum]?.interestRate || "0"}%
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap="10px">
                                        <Grid item xs={12} className={styles.sectionTitle}>Account Setup</Grid>
                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs={10} className={styles.outputLabel}>Annual Contribution</Grid>
                                                <Grid item xs={2} className={styles.outputValue}>
                                                    {formatNumber(finalData?.accumulation_plan?.[changeYearAccum]?.contribution) || "$0"}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap="10px">
                                        <Grid item xs={12} className={styles.sectionTitle}>Returns & Fees</Grid>
                                        <Grid item xs={12}>
                                            {(() => {
                                                const feeRate = Number(finalData?.accumulation_plan?.[changeYearAccum]?.feeRate || 0);
                                                const annualFeesPercentDisplay = feeRate === 0 ? formatNumber(0) : `${feeRate}%`;
                                                return (
                                                    <Grid container>
                                                        <Grid item xs={10} className={styles.outputLabel}>Annual Fees %</Grid>
                                                        <Grid item xs={2}>
                                                            <Grid container alignItems="center" gap="5px">
                                                                <Grid item className={styles.iulFeesValue}>{annualFeesPercentDisplay}</Grid>
                                                                <Grid item>
                                                                    <span className={styles.iulFeesText}>{feeRate === 0 ? "No Extra" : "Extra"}</span>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )
                                            })()}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={styles.lightblueContainer}>
                            <Grid container gap="10px">
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" gap="10px">
                                        <Grid item>
                                            <span style={{ display: "inline-block", width: "4px", height: "18px", backgroundColor: "#3B78CE", borderRadius: "2px" }} />
                                        </Grid>
                                        <Grid item>
                                            <Typography component={"span"} className={styles.sectionTitle}>
                                                Fees - Includes Life Insurance
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Annual Fees</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.accumulation_plan?.[changeYearAccum]?.fees) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} className={styles.totalValueContainer}>
                                    <Grid container>
                                        <Grid item xs={10} className={styles.outputLabel}>Total Fees Paid</Grid>
                                        <Grid item xs={2} className={styles.outputValue}>
                                            {formatNumber(finalData?.accumulation_plan?.[changeYearAccum]?.totalFeesPaid) || "$0"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AnnuityFeesTab
